import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Header from "../components/Landing/Header.jsx";
import "../styles/landing-page.css";
import Footer from "../components/Landing/footer.jsx";
import useRestoreScroll from "../hooks/useRestoreScroll.js";

// FAQ items will be loaded from translations

const Contact = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === 'ar';
  const isRTL = i18n.dir && i18n.dir() === 'rtl';
  const fontFamily = isArabic ? '"Cairo", sans-serif' : '"Red Hat Display", sans-serif';
  useRestoreScroll();

  // Ensure body overflow is restored when component mounts (fix for scroll issues)
  useEffect(() => {
    // Restore body overflow on mount
    document.body.style.overflow = '';
    document.body.style.overflowY = '';

    // Cleanup: ensure overflow is restored on unmount
    return () => {
      document.body.style.overflow = '';
      document.body.style.overflowY = '';
    };
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  const [openIndex, setOpenIndex] = useState(null);
  const toggleIndex = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };
  // Helper to detect mobile device
  const isMobile = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  };

  const email = "support@sulhafa.com";

  // Get FAQ items from translations
  const faqItems = Array.isArray(t("faq.items", { returnObjects: true }))
    ? t("faq.items", { returnObjects: true })
    : [];


  const handleEmailClick = () => {
    window.location.href = `mailto:${email}`;
  };

  return (
    <div className="contact-page" style={{ position: "relative" }}>
      <Header />
      {/* Contact Section */}
      <section className="contact-section">
        <div className="contact-left">
          <h1 className="contact-title">{t("contactPage.title")}</h1>
          <p className="contact-desc">
            {t("contactPage.description")}
          </p>
          <div className="contact-info-row">
            <button className="contact-info-btn" onClick={handleEmailClick}>
              {email}
            </button>
          </div>
          <div style={{ marginTop: "32px" }}>
            <img
              src="/images/Sulhafa-Community.png"
              alt="Sulhafa Character"
              style={{
                width: "200px",
                borderRadius: "16px",
                transform: "scale(1.2) scaleX(-1)"
              }}
            />
          </div>
        </div>
        <form className="contact-form">
          <div style={{ textAlign: "center", marginBottom: "24px" }}>
            <h3 style={{
              fontFamily: fontFamily,
              fontWeight: 600,
              fontSize: "1.3rem",
              color: "#222e3a",
              margin: 0
            }}>
              {t("contactPage.form.title")}
            </h3>
            <p style={{
              fontFamily: fontFamily,
              fontSize: "0.95rem",
              color: "#666",
              margin: "8px 0 0 0"
            }}>
              {t("contactPage.form.subtitle")}
            </p>
          </div>
          <div className="form-group">
            <label htmlFor="name">{t("contactPage.form.fields.name.label")}</label>
            <input type="text" id="name" name="name" placeholder={t("contactPage.form.fields.name.placeholder")} />
          </div>
          <div className="form-group">
            <label htmlFor="email">{t("contactPage.form.fields.email.label")}</label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder={t("contactPage.form.fields.email.placeholder")}
            />
          </div>
          <div className="form-group">
            <label htmlFor="message">{t("contactPage.form.fields.message.label")}</label>
            <textarea
              id="message"
              name="message"
              placeholder={t("contactPage.form.fields.message.placeholder")}
              rows={4}
            />
          </div>
          <button type="submit" className="contact-submit-btn">
            {t("contactPage.form.submit")}
          </button>
          <div className="contact-form-note">
            {t("contactPage.form.replyNote")}
          </div>
        </form>
      </section>

      {/* FAQ Section Below Contact */}
      <section
        className="faq-section"
        style={{ minHeight: "100vh", background: "#fff" }}
      >
        <div
          className="faq-container"
          style={{
            display: "flex",
            gap: "32px",
            maxWidth: "1200px",
            margin: "0 auto",
            paddingTop: "48px",
          }}
        >
          {/* Left Side - Header and Buttons */}
          <div className="faq-left" style={{ flex: 1 }}>
            <h2
              style={{
                fontFamily: fontFamily,
                fontWeight: 700,
                fontSize: "2.5rem",
                color: "#222e3a",
                marginBottom: "18px",
                textAlign: isRTL ? "right" : "left",
              }}
            >
              {t("contactPage.faq.title")}
            </h2>
            <p
              style={{
                fontFamily: fontFamily,
                fontSize: "1.1rem",
                color: "#222e3a",
                marginBottom: "32px",
                maxWidth: "420px",
                lineHeight: "1.6",
                textAlign: isRTL ? "right" : "left",
              }}
            >
              {t("contactPage.faq.subtitle")}
            </p>

            <img
              src="/images/Sulhafa-Main.png"
              alt="Sulhafa Character"
              style={{
                width: "280px",
                marginTop: "24px",
                borderRadius: "20px",
                transform: "scale(1.8) scaleX(-1)"
              }}
            />
          </div>
          {/* Right Side - Questions */}
          <div className="faq-right" style={{ flex: 1.2 }}>
            <div
              className="faq-questions-container"
              style={{
                background: "#fff",
                borderRadius: "18px",
                boxShadow: "0 2px 16px rgba(48,62,78,0.08)",
                padding: "32px 32px 24px 32px",
                minWidth: "340px",
                maxWidth: "480px",
                direction: isRTL ? "rtl" : "ltr",
              }}
            >
              <div
                className="add-question"
                style={{
                  marginBottom: "18px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexDirection: isRTL ? "row-reverse" : "row",
                }}
              >
                <span
                  style={{
                    fontWeight: 700,
                    fontSize: "1.1rem",
                    color: "#222e3a",
                    textAlign: isRTL ? "right" : "left",
                    direction: isRTL ? "rtl" : "ltr",
                  }}
                >
                  {t("contactPage.faq.addQuestion")}
                </span>
                <button
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    padding: 0,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <line
                      x1="12"
                      y1="5"
                      x2="12"
                      y2="19"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                    <line
                      x1="5"
                      y1="12"
                      x2="19"
                      y2="12"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                </button>
              </div>
              <div className="faq-items">
                {faqItems.map((item, i) => (
                  <div
                    key={i}
                    className={`faq-item${openIndex === i ? " open" : ""}`}
                    style={{
                      borderBottom: "1px solid #f0f2f5",
                      padding: "12px 0",
                    }}
                  >
                    <button
                      className="faq-question"
                      onClick={() => toggleIndex(i)}
                      aria-expanded={openIndex === i}
                      style={{
                        background: "none",
                        border: "none",
                        width: "100%",
                        textAlign: isRTL ? "right" : "left",
                        fontFamily: fontFamily,
                        fontWeight: 500,
                        fontSize: "1.08rem",
                        color: "#222e3a",
                        cursor: "pointer",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexDirection: isRTL ? "row-reverse" : "row",
                        direction: isRTL ? "rtl" : "ltr",
                      }}
                    >
                      <span style={{
                        textAlign: isRTL ? "right" : "left",
                        direction: isRTL ? "rtl" : "ltr",
                        flex: 1,
                        paddingRight: isRTL ? "0" : "8px",
                        paddingLeft: isRTL ? "8px" : "0",
                      }}>{typeof item === 'object' ? item.q : item}</span>
                      <svg
                        className="toggle-icon"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        {openIndex === i ? (
                          <path
                            d="M18 6L6 18M6 6l12 12"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        ) : (
                          <>
                            <line
                              x1="12"
                              y1="5"
                              x2="12"
                              y2="19"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                            />
                            <line
                              x1="5"
                              y1="12"
                              x2="19"
                              y2="12"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                            />
                          </>
                        )}
                      </svg>
                    </button>
                    {openIndex === i && (
                      <div
                        className="faq-answer"
                        style={{
                          marginTop: "8px",
                          fontSize: "1rem",
                          color: "#444",
                          fontFamily: fontFamily,
                          textAlign: isRTL ? "right" : "left",
                          direction: isRTL ? "rtl" : "ltr",
                        }}
                      >
                        <p style={{
                          textAlign: isRTL ? "right" : "left",
                          direction: isRTL ? "rtl" : "ltr",
                          margin: 0,
                        }}>{typeof faqItems[openIndex] === 'object' && faqItems[openIndex]?.a ? faqItems[openIndex].a : t("contactPage.faq.answerComingSoon")}</p>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Contact;
